import type { UiMessage } from '../index.h'

import { ErrorMessage as ErrorMessageUI } from "/app/libraries/arcana/src/atoms/ErrorMessage/index.ts"

import { useUnit } from 'effector-react'
import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { UI_MESSAGE_TYPE } from '~/shared/constants/uiMessage'
import * as model from '../model'
import { useMessageHeight } from './useMessageHeight'

// put it in widget or route to render warning message in MessagePortal
export const useWarningMessage = (message: UiMessage, key: string) => {
  const setNewMessage = useUnit(model.setNewMessage)

  useEffect(() => {
    setNewMessage({ key, message, type: UI_MESSAGE_TYPE.WARNING })
  }, [setNewMessage, key, message])
}

// put it in widget or route to render error message in MessagePortal
export const useErrorMessage = (message: UiMessage, key: string) => {
  const setNewMessage = useUnit(model.setNewMessage)

  useEffect(() => {
    setNewMessage({ key, message, type: UI_MESSAGE_TYPE.ERROR })
  }, [setNewMessage, key, message])
}

// Should be one per route
// This is a sticky toast from bottom of the page, red for errors, yellow for policy message
export const MessagePortal = () => {
  const updateMessageHeight = useUnit(model.setMessageHeight)

  const setRef = useMessageHeight(updateMessageHeight)

  const { show, title, type } = useUnit(model.$messageToShow)

  if (!show) return null

  return (
    <>
      {createPortal(
        <ErrorMessageUI
          setRef={setRef}
          warning={type === UI_MESSAGE_TYPE.WARNING}
          title={title}
        />,
        document.body,
        'toast_messages_portal'
      )}
    </>
  )
}
